// Type definitions for OrderDetails modal components

export interface TransmissionEvent {
  id: string;
  ofId: string;
  ofIdType: string;
  to: string;
  toType: string;
  newState: string;
  isDeliveryEvent: boolean;
  isFailureEvent: boolean;
  timestamp: string;
  metaData?: string | null;
}

export interface OrderProduct {
  id: string;
  externalId?: string | null;
  name: string;
  unit: string;
  amount: number;
}

export interface OrderUser {
  id: string;
  name?: string | null;
  phone?: string | null;
}

export interface OrderBuyer {
  id: string;
  name?: string | null;
  fullAddress?: string | null;
}

export interface OrderSupplier {
  id: string;
  name?: string | null;
}

export interface OrderChat {
  id: string;
  deliveryAddress?: string | null;
}

export enum OrderCreatedContext {
  ChocoApp = 'CHOCO_APP',
  ChocoAi = 'CHOCO_AI',
  ChocoWeb = 'CHOCO_WEB',
  TeamOrder = 'TEAM_ORDER',
  WhiteLabelApp = 'WHITE_LABEL_APP',
  WhiteLabelWeb = 'WHITE_LABEL_WEB',
}

export interface OrderDetails {
  id: string;
  referenceId: string;
  status: string;
  createdAt: number;
  deliveryDate?: string | null;
  body?: string | null;
  pdf?: string | null;
  isTest?: boolean | null;
  createdContext?: OrderCreatedContext | null;
  user?: OrderUser | null;
  buyer?: OrderBuyer | null;
  supplier?: OrderSupplier | null;
  chat?: OrderChat | null;
  products: OrderProduct[];
}

export interface OrderDetailsModalProps {
  orderId: string | null;
  isOpen: boolean;
  onClose: () => void;
}

export interface HeaderProps {
  order: OrderDetails | null;
  isLoading: boolean;
}

export interface InternalReportingProps {
  orderId: string;
  isTest: boolean;
}

export interface TransmissionEventTableProps {
  isLoading: boolean;
  transmissionEvents: TransmissionEvent[];
  orderCreatedAt?: number;
}

export interface TransmissionEventChannelsProps {
  transmissionEvents: TransmissionEvent[];
  orderCreatedAt?: number;
}

export interface TransmissionEventChannelProps {
  channelEvents: TransmissionEvent[];
  orderCreatedAt?: number;
}

export interface TransmissionEventRowProps {
  transmissionEvent: TransmissionEvent;
  orderCreatedAt?: number;
}

export interface ProductsTableProps {
  isLoading: boolean;
  products: OrderProduct[];
}
